import { Store } from 'vuex';
import { RootState } from '@/store/types';

import { RelatedItemsModuleViewModel, convertToGridConfig } from './RelatedItemsModule.types';

import registerModule from '@/modules/FilterableGridModule/FilterableGridModule.store';

export default async (store: Store<RootState>, data: RelatedItemsModuleViewModel) => {
  if (data.IsGrid) {
    return registerModule(store, convertToGridConfig(data));
  } else {
    return null;
  }
};
